// VIBRANIAM-SPACE v2 - ResizeHandle.jsx
// Thin draggable bar, same visual language as the existing viewport/editor
// split handle in App.jsx. Purely presentational - the drag math lives with
// whatever state it resizes, same as that existing handle.

import React from 'react';

export default function ResizeHandle({ orientation = 'vertical', onPointerDown, title }) {
  const isVertical = orientation === 'vertical'; // a vertical bar resizes width (drag left/right)
  return (
    <div
      onPointerDown={onPointerDown}
      title={title || 'Trascina per ridimensionare'}
      className={
        isVertical
          ? 'w-1.5 shrink-0 cursor-col-resize bg-white/5 transition hover:bg-vibe-cyan/40'
          : 'h-1.5 shrink-0 cursor-row-resize bg-white/5 transition hover:bg-vibe-cyan/40'
      }
    />
  );
}
